export default {"src":"/_next/static/media/serbia.00bbe31d.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};